import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { usingWebOnMobile1whyqijwjkjd1 as usingWebOnMobile } from './NumberField.commonHtml.js.mjs';
import { listOfNotNull2woi2boe01ub4 as listOfNotNull } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function applyKeyboardHints(_this__u8e3s4, hints) {
  var tmp0 = _this__u8e3s4.bb4_1;
  var tmp;
  switch (hints.jbu_1.b4_1) {
    case 0:
      tmp = 'text';
      break;
    case 3:
      tmp = 'text';
      break;
    case 1:
      tmp = 'text';
      break;
    case 2:
      tmp = 'tel';
      break;
    case 4:
      tmp = 'text';
      break;
    case 5:
      tmp = 'text';
      break;
    case 6:
      tmp = 'text';
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  // Inline function 'com.lightningkite.kiteui.views.type' call
  var value = tmp;
  tmp0.kb7_1.type = value;
  var tmp0_0 = _this__u8e3s4.bb4_1;
  var tmp_0;
  switch (hints.jbu_1.b4_1) {
    case 0:
      tmp_0 = 'text';
      break;
    case 3:
      tmp_0 = 'decimal';
      break;
    case 1:
      tmp_0 = 'numeric';
      break;
    case 2:
      tmp_0 = 'tel';
      break;
    case 4:
      tmp_0 = 'email';
      break;
    case 5:
      tmp_0 = usingWebOnMobile() ? 'text' : 'numeric';
      break;
    case 6:
      tmp_0 = usingWebOnMobile() ? 'text' : 'decimal';
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  // Inline function 'com.lightningkite.kiteui.views.inputMode' call
  var value_0 = tmp_0;
  tmp0_0.kb7_1.inputMode = value_0;
  var primaryAutocompleteValue;
  var tmp2_subject = hints.kbu_1;
  switch (tmp2_subject == null ? -1 : tmp2_subject.b4_1) {
    case 0:
      // Inline function 'com.lightningkite.kiteui.views.type' call

      _this__u8e3s4.bb4_1.kb7_1.type = 'email';
      primaryAutocompleteValue = 'email';
      break;
    case 1:
      var tmp0_1 = _this__u8e3s4.bb4_1;
      // Inline function 'com.lightningkite.kiteui.views.type' call

      var value_1 = 'password';
      tmp0_1.kb7_1.type = value_1;
      primaryAutocompleteValue = 'current-password';
      break;
    case 2:
      var tmp0_2 = _this__u8e3s4.bb4_1;
      // Inline function 'com.lightningkite.kiteui.views.type' call

      var value_2 = 'password';
      tmp0_2.kb7_1.type = value_2;
      primaryAutocompleteValue = 'new-password';
      break;
    case 3:
      primaryAutocompleteValue = 'tel';
      break;
    case 4:
    case -1:
      primaryAutocompleteValue = null;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  var tmp0_3 = _this__u8e3s4.bb4_1;
  // Inline function 'kotlin.takeIf' call
  var this_0 = 'webauthn';
  var tmp_1;
  if (hints.lbu_1) {
    tmp_1 = this_0;
  } else {
    tmp_1 = null;
  }
  var tmp$ret$6 = tmp_1;
  // Inline function 'kotlin.takeIf' call
  var this_1 = joinToString(listOfNotNull([primaryAutocompleteValue, tmp$ret$6]), ' ');
  var tmp_2;
  // Inline function 'kotlin.text.isNotEmpty' call
  if (charSequenceLength(this_1) > 0) {
    tmp_2 = this_1;
  } else {
    tmp_2 = null;
  }
  var tmp3_elvis_lhs = tmp_2;
  // Inline function 'com.lightningkite.kiteui.views.autocomplete' call
  var value_3 = tmp3_elvis_lhs == null ? 'off' : tmp3_elvis_lhs;
  tmp0_3.kb7_1.autocomplete = value_3;
}
//region block: exports
export {
  applyKeyboardHints as applyKeyboardHints2y8fo0b5cldu1,
};
//endregion

//# sourceMappingURL=KeyboardHints.ext.mjs.map
